import io from "socket.io-client";
import { url } from "./utils/const";

const sessionId = localStorage.getItem('sessionId');

export const socket = io(url, {
    autoConnect: true,
    withCredentials: true,
    auth: {
        sessionId
    }
});

 // db.jackpots.update({point:ObjectId("636c5e19fff7eadd671e7e50")},{$set:{amountToPay:4500}})
// db.jackpots.update({_id: ObjectId("636a58dc0a7910f7e2026067")},{$set:{amountToPay:16200}})
